module.exports = __webpack_public_path__ + "media/images/khqr_footer_logo_2x-c6d8fa908140320f58e7d6abd5147011.png";